import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import translator from "../../Assets/Projects/translator.jpg";
import social from "../../Assets/Projects/social.jpg";
import shopify from "../../Assets/Projects/deliver.png";
import rope from "../../Assets/Projects/rope.jpg";
import qrcode from "../../Assets/Projects/qrcode.jpg";
import app from "../../Assets/Projects/app.jpg";
import cake from "../../Assets/Projects/cake.jpg";
import skin from "../../Assets/Projects/skin.jpg";
import food from "../../Assets/Projects/food.jpg";
import extension from "../../Assets/Projects/extension.jpg";
import Ethermail from "../../Assets/Projects/Ethermail.jpg";


import fan from "../../Assets/Projects/fan.jpg";
import beauty from "../../Assets/Projects/buy_sell.png";
import golf from "../../Assets/Projects/golf.jpg";
import baby from "../../Assets/Projects/baby.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked in the past.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={beauty}
              isBlog={false}
              title="Permitted Drawing"
              description="During my tenure at CH Architects PLLC, I led a multi-disciplinary team on a project in Anaheim, CA. Adhering to local building codes, we successfully completed the project, achieving significant milestones. It was an exhilarating experience."
              // ghLink="https://github.com/soumyajit4419/Chatify"
              demoLink="https://drive.google.com/drive/folders/1NBoTNvYLf_l1fnOULcI-d-MkZ5-Kwl9m?usp=sharing"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cake}
              isBlog={false}
              title="Dynamic Visualization"
              description="Leveraging my extensive experience in interior and exterior design, I led my talented team to complete this project on time and within budget. Through strong verbal and written communication skills, we maintained close rapport with clients, capturing and realizing their vision, requirements, and dreams. Architecture shapes our future—let's build a lasting legacy together."
              //ghLink="https://github.com/soumyajit4419/Bits-0f-C0de"
              demoLink="https://drive.google.com/file/d/1TN9CCnxD-R7f7V01iKqiG5e3Jlv0ybj_/view?usp=sharing"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={skin}
              isBlog={false}
              title="Enchanted Nightscape"
              description="Harmonizing with natural elements, the design of the garden and lighting effects create a stunning picturesque atmosphere. Featuring a pergola, vibrant flowers, a stylish bar, and a cozy swimming pool, the space transforms the client's life into a delightful experience. The outdoor environment significantly enhances this feeling of wonder and serenity."
              //ghLink="https://github.com/soumyajit4419/Bits-0f-C0de"
              demoLink="https://drive.google.com/file/d/1ZwOkkj4oCgatg6DZAOPwjZz6ck9xxC9-/view?usp=sharing"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={baby}
              isBlog={false}
              title="The Essence of Geometry"
              description="At CH Architects PLLC, my tenure has been marked by a relentless and responsible drive towards success. It demonstrates the transformative power of architecture through the lens of geometry."
              //ghLink="https://github.com/soumyajit4419/Bits-0f-C0de"
              demoLink="https://drive.google.com/file/d/1l3x1gHsYbrZwbU77FvLwO8zJGB75jKJy/view?usp=sharing"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={shopify}
              isBlog={false}
              title="Bathroom Design"
              description="During my tenure at Minta Bell Design Group, I built strong client relationships, ensuring their visions, requirements, and dreams were flawlessly reflected in every project, including this bathroom design."
              //ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
              demoLink="https://drive.google.com/file/d/1U8TgGX_H9LZxgrxQoWQJuMopKdjg6Ms8/view?usp=sharing"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={rope}
              isBlog={false}
              title="Open Office"
              description="This office design exemplifies our mastery in harmonizing spaciousness with color and light to achieve a seamless blend of style and functionality. By meticulously balancing flexibility and scale, we've crafted a patterned environment that enhances efficiency. Our approach ensures every open office space we design prioritizes user comfort and convenience, seamlessly integrating architecture and interior expertise."
              //ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
              demoLink="https://drive.google.com/file/d/11aBApEuR5qmM5V5xWHAShv8PKD98Exgn/view?usp=sharing"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={qrcode}
              isBlog={false}
              title="For manager"
              description="This room is tailored for company managers, fostering meticulous thought and careful decision-making, paving the path for outstanding success in the company's future."
              //ghLink="https://github.com/soumyajit4419/Editor.io"
              demoLink="https://drive.google.com/file/d/1DhxecENOHr91UOjfcdg7lCFuqmcyLiER/view?usp=sharing"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={app}
              isBlog={false}
              title="Airbnb"
              description="With skill and imagination, every host can transform their properties into sought-after destinations for short-term lodging."
              //ghLink="https://github.com/soumyajit4419/Editor.io"
              demoLink="https://drive.google.com/file/d/10M4SiK41NHNuD_DzEgmpidOSaByPyAZI/view?usp=sharing"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={translator}
              isBlog={false}
              title="An array of perspectives"
              description="Our projects, rooted in wooden design, evoke a serene, timeless, and deeply familiar ambiance."
              //ghLink="https://github.com/soumyajit4419/Plant_AI"
              demoLink="https://drive.google.com/file/d/1V-NELYvHJCVmBUitZwpWWl4Lu8obrMEh/view?usp=sharing"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={golf}
              isBlog={false}
              title="Iconic Landscape Design for Building Group"
              description="During my university years, I actively engaged in competitive bidding."
              //ghLink="https://github.com/soumyajit4419/AI_For_Social_Good"
              demoLink="https://drive.google.com/file/d/1wLUPZflyk1Kvue24C9HsLDB4JWLPavtk/view?usp=sharing"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={extension}
              isBlog={false}
              title="Urban Planning with Lasting Impact"
              description="During my university years, I actively engaged in competitive bidding."
              //ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
              demoLink="https://drive.google.com/file/d/15YqqYatgtZ2fdE7N4Slrydh2j81TiG5e/view?usp=sharing"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={social}
              isBlog={false}
              title="Design for Residential Building"
              description="Welcome our citizens!"
              //ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
              demoLink="https://drive.google.com/file/d/1cYcdDXwbqjd7PYd1FCB10Q9sOmbKSLwd/view?usp=sharing"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={food}
              isBlog={false}
              title="Commercial Building"
              description="What an exquisite design!"
              //ghLink="https://github.com/soumyajit4419/Bits-0f-C0de"
              demoLink="https://drive.google.com/file/d/1NnmQ2xxGhbV-Navwr9IEo4ZV-pVjmtIV/view?usp=sharing"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Ethermail}
              isBlog={false}
              title="Luxury Design"
              description="Seeking a suite? Contact us today. Here we are because we are providing unprecedented spatial feeling and make clients' vision and dream reality.
              Wonderful furnitures and fixtures would be suitable for your life. Let's build our life together."
              //ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
              demoLink="https://drive.google.com/file/d/1Jch67a9lCvEsAkRz6tZ1wstA4qdui0PM/view?usp=sharing"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={fan}
              isBlog={false}
              title="From start to finish"
              description="We've achieved it remotely with resounding success. Complying with local codes and building regulations, we have done several projects within timeline and
              budget constraint."
              //ghLink="https://github.com/soumyajit4419/Editor.io"
              demoLink="https://drive.google.com/drive/folders/1iaKVyjQoUfnHU2LfqSK8HIaNRnc45Og2?usp=sharing"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
